import { render } from "./SmartDataTable.vue?vue&type=template&id=0e0f4e66"
import script from "./SmartDataTable.vue?vue&type=script&lang=js"
export * from "./SmartDataTable.vue?vue&type=script&lang=js"

import "./SmartDataTable.vue?vue&type=style&index=0&id=0e0f4e66&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__